import type { Action } from '@protector/utils/types';
import { selectSelectedProperty } from 'core/core.reducer';
import { selectAllProperties } from 'entities/property/property.selectors';
import type { ActionsObservable, StateObservable } from 'redux-observable';
import { ofType } from 'redux-observable';
import type { AppState } from 'redux/app-state';
import { of } from 'rxjs';
import { catchError, concatMap, map, withLatestFrom } from 'rxjs/operators';
import { AssigneeActionsTypes, LoadAssigneesFailure, LoadAssigneesSuccess } from './assignee.actions';
import type { AssigneePage, PayloadAssigneesType } from '@protector/entities/assignee/models';
import { getAssigneePage } from './assignee.service';

export const handleLoadAssignees = (action$: ActionsObservable<Action<PayloadAssigneesType>>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType(AssigneeActionsTypes.LOAD_ASSIGNEES),
    map((action: Action<PayloadAssigneesType>) => action.payload),
    withLatestFrom(
      state$.pipe(map((state: AppState) => selectSelectedProperty(state.uiState.global))),
      state$.pipe(map((state: AppState) => selectAllProperties(state).map(property => property.id)))
    ),
    concatMap(([payload, property_id, property_ids]) => {
      if (!payload?.company_id) return of(LoadAssigneesFailure('company id is required'));
      return getAssigneePage(payload?.company_id, property_id ? [property_id] : property_ids, payload?.only_accounts_workers).pipe(
        map(response => response.data),
        map((assigneePage: AssigneePage) => {
          return LoadAssigneesSuccess(assigneePage);
        }),
        catchError((error: string) => of(LoadAssigneesFailure(error)))
      );
    })
  );
